/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationQualificationsAliases {
  AVATAR = 'avatar',
  CARD_QUALIFICATION = 'card-qualification',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  FETCH_0 = 'fetch-0',
  FETCH_ACCREDITATION = 'fetch-accreditation',
  FETCH_FORM_QUALIFICATION = 'fetch-form-qualification',
  FETCH_LEVEL = 'fetch-level',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FETCH_QUALIFICATIONS = 'fetch-qualifications',
  FETCH_TYPE = 'fetch-type',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_ACCREDITATION = 'field-accreditation',
  FIELD_ACCREDITATION_LEVEL = 'field-accreditation-level',
  FIELD_ACCREDITATION_TYPE = 'field-accreditation-type',
  FIELD_DATE_END = 'field-date-end',
  FIELD_DT_BEGINNING = 'field-dt-beginning',
  FIELD_INSTITUTION = 'field-institution',
  FIELD_PENDENCY = 'field-pendency',
  FIELD_VALIDITY = 'field-validity',
  FORM_PENDENCY = 'form-pendency',
  FORM_QUALIFICATION = 'form-qualification',
  LAYOUT_QUALIFICATIONS = 'layout-qualifications',
  LEGENDS = 'legends',
  MAPPER_3 = 'mapper-3',
  MAPPER_10 = 'mapper-10',
  MAPPER_ACCREDITATION = 'mapper-accreditation',
  MAPPER_ACCREDITATION_TYPE = 'mapper-accreditation-type',
  MAPPER_LEVEL = 'mapper-level',
  PANEL_ACCREDITATION_QUALIFICATIONS = 'panel-accreditation-qualifications',
  PANEL_DATA = 'panel-data',
  PANEL_FORM = 'panel-form',
  PANEL_PENDENCIES = 'panel-pendencies',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_ACCREDITATION = 'text-accreditation',
  TEXT_ACCREDITATION_TYPE = 'text-accreditation-type',
  TEXT_INSTITUTION = 'text-institution',
  TEXT_LEVEL = 'text-level',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_AUTOCOMPLETE_0 = 'unboxed-autocomplete-0',
  UNBOXED_AUTOCOMPLETE_1 = 'unboxed-autocomplete-1',
  UNBOXED_AUTOCOMPLETE_ACCREDITATION = 'unboxed-autocomplete-accreditation',
  UNBOXED_AUTOCOMPLETE_LEVEL = 'unboxed-autocomplete-level',
}
export { AccreditationQualificationsAliases };
